<!--
 * @Author: zhouhx
 * @Date: 2024-02-28 09:27:00
 * @LastEditors: zhouhx
 * @LastEditTime: 2024-02-29 10:20:00
 * @Description:新建/编辑申请 转诊时间设置
-->
<template>
    <div class="date-setting">
        <div class="urgentCont" @click="showDatePicker()">
            <span>转诊日期</span>
            <p>{{ datesetting.date === "" ? "请选择日期" : datesetting.date }}</p>
            <van-icon name="arrow" class="icon" />
        </div>
        <div class="urgentCont" @click="showDatePicker('time')">
            <span>开始时间</span>
            <p>{{ datesetting.time === "" ? "请选择时间" : datesetting.time }}</p>
            <van-icon name="arrow" class="icon" />
        </div>

        <!-- 选择日期 -->
        <van-datetime-picker v-show="datesetting.dataPickerShow" class="fixed" v-model="datesetting.currentDate"
            type="date" :title="datesetting.timeDateName" :min-date="datesetting.minDate"
            :max-date="datesetting.maxDate" @confirm="confirm" @cancel="datesetting.dataPickerShow = false" />
        <!-- 选择时间 -->
        <van-datetime-picker v-show="datesetting.timePickerShow" class="fixed" v-model="datesetting.currentTime"
            type="time" :title="datesetting.timeDateName" :min-hour="datesetting.minHour"
            :min-minute="datesetting.minMinute" @confirm="confirm"
            @cancel="datesetting.timePickerShow = false" />
        <div class="addPart haveBorder" v-if="date_setting.showTimeBtnStatus">
            <span class="dialog-footer">
                <button class="comfirmBtn" @click="selectedTime()">确定</button>
            </span>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    search: {}
  },
  data () {
    return {
      date_setting: {
        showTimeBtnStatus: false
      },
      // 时间控件参数
      datesetting: {
        // 统一调配参数
        timePickerShow: false,
        dataPickerShow: false,
        timeDateName: '',
        minDate: new Date(),
        maxDate: new Date(2099, 12, 1),
        currentDate: new Date(),
        timeType: '',
        minHour: '0',
        minMinute: '0',
        // 期望日期
        date: '',
        // 期望时间
        time: ''
      },
      expertNextData: {}
    };
  },
  created () {
  },
  methods: {
    getTimeData () {
      // 2024-02-28 15:57:00
      const datatime = this.search.expectationTime // 2024-02-28
      this.datesetting.date = datatime.split(' ')[0]
      this.datesetting.time = datatime.split(' ')[1].split(':')[0] + ':' + datatime.split(' ')[1].split(':')[1]
      this.date_setting.showTimeBtnStatus = true
    },
    // 预约时间
    // 唤起 日期/时间 选择器
    showDatePicker (type) {
      this.date_setting.showTimeBtnStatus = false;
      if (type === 'time') {
        if (!this.datesetting.date) {
          this.$toast('请先选择转诊日期');
          return;
        }
        // 时间选择器
        this.datesetting.dataPickerShow = false;
        this.datesetting.timeDateName = '选择时间';
        this.datesetting.timeType = type;
        this.datesetting.timePickerShow = true;
        this.datesetting.minHour =
                    this.datesetting.currentDate.getHours();
        this.datesetting.minMinute =
                    this.datesetting.currentDate.getMinutes();
      } else {
        // 日期选择器
        this.datesetting.timePickerShow = false;
        this.datesetting.timeDateName = '选择日期';
        this.datesetting.timeType = 'date';
        this.datesetting.dataPickerShow = true;
      }
    },
    // 时间控件函数
    // 确定-选择开始时间、结束时间
    confirm (e) {
      if (this.datesetting.timeType === 'date') {
        this.datesetting.date = this.utils.formatDate(
          e,
          'YYYY-MM-DD'
        );
        this.datesetting.dataPickerShow = false;
      } else if (this.datesetting.timeType === 'time') {
        this.datesetting.time = e;
        this.datesetting.timePickerShow = false;
      }
      this.date_setting.showTimeBtnStatus = true
    },
    // 时间 小时改动 分钟对应改动
    // changeTime (a) {
    //   var currentHours = Number(a.getValues()[0]);
    //   if (currentHours !== this.datesetting.minHour) {
    //     this.minMinutes = this.datesetting.minMinute;
    //     this.datesetting.minMinute = '0';
    //   } else {
    //     this.datesetting.minMinute = this.minMinutes;
    //   }
    // },
    // 固定间隔15分钟
    // filter (type, options) {
    //   if (type === 'minute') {
    //     return options.filter((option) => option % 15 === 0);
    //   }
    //   return options;
    // },
    // 填充时间
    // 确认-年月日 时分-十分 填充至界面
    selectedTime () {
      var referralTime =
                this.datesetting.date +
                ' ' +
                this.datesetting.time;

      if (!this.datesetting.time) {
        this.$toast('请选择转诊时间');
        return;
      }
      const jsondata = {
        value: referralTime
      }
      this.$emit('getTime', jsondata)
    }
  }
};
</script>
<style lang="scss" scoped>
.date-setting {

    //   时间选择器样式
    .urgentCont {
        height: 52px;
        line-height: 52px;
        position: relative;
        padding: 0 20px;

        p {
            float: right;
            margin-right: 45px;
            color: #858585;
        }
    }

    .comfirmBtn {
        width: 100%;
        height: 52px;
        background-image: linear-gradient(90deg, #5c94ff 21%, #477de5 83%);
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        font-weight: 500;
    }
}
</style>
